import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { ArrowLeft, FileText } from 'lucide-react';

const TermsPage = () => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen bg-slate-50 py-12 px-4" data-testid="terms-page">
      <div className="max-w-4xl mx-auto">
        {/* Back Button */}
        <Link 
          to="/" 
          className="inline-flex items-center text-slate-600 hover:text-slate-900 mb-8"
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          Torna alla Home
        </Link>

        {/* Header */}
        <div className="bg-white rounded-lg shadow-sm border border-slate-200 p-8 mb-8">
          <div className="flex items-center gap-4 mb-6">
            <div className="w-12 h-12 bg-slate-900 rounded-sm flex items-center justify-center">
              <FileText className="h-6 w-6 text-orange-500" />
            </div>
            <div>
              <h1 className="text-3xl font-bold text-slate-900" style={{ fontFamily: 'IBM Plex Sans, sans-serif' }}>
                Termini di Servizio
              </h1>
              <p className="text-slate-500">Ultimo aggiornamento: 23/03/2026</p>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="bg-white rounded-lg shadow-sm border border-slate-200 p-8 prose prose-slate max-w-none">
          
          <h2 className="text-xl font-semibold text-slate-900 mt-0">Art. 1 – Oggetto del Servizio</h2>
          <p>
            La piattaforma <strong>Automat.io</strong> (di seguito "App"), gestita da <strong>Delta Impianti Polska (Delta)</strong>, 
            con sede legale in ul. św. Antoniego Padewskiego 5/7, 90-038 Lodz, NIP 7272835952, fornisce un servizio 
            di directory (elenco) professionale. L'App permette l'incontro tra Professionisti del settore automazione 
            industriale e Aziende manifatturiere. Il Servizio si limita alla messa in contatto e non include 
            l'intermediazione nelle trattative o l'esecuzione delle prestazioni lavorative.
          </p>

          <h2 className="text-xl font-semibold text-slate-900">Art. 2 – Requisiti e Registrazione</h2>
          <p>
            L'accesso all'App è riservato esclusivamente a utenti professionali (B2B). L'utente dichiara di possedere 
            le competenze tecniche o i poteri di rappresentanza aziendale necessari. La registrazione è completa solo 
            dopo il pagamento della quota di iscrizione prevista.
          </p>

          <h2 className="text-xl font-semibold text-slate-900">Art. 3 – Quote di Iscrizione e Abbonamento</h2>
          <p>
            <strong>3.1 Quota di Iscrizione Iniziale:</strong> L'accesso alle funzionalità di contatto e visibilità è subordinato 
            al pagamento di una quota iniziale di <strong>€2,50</strong>.
          </p>
          <p>
            <strong>3.2 Abbonamento di Rinnovo:</strong> Dopo il primo anno dalla registrazione, per continuare ad usufruire 
            del servizio è necessario sottoscrivere un abbonamento a scelta tra:
          </p>
          <ul className="list-disc list-inside ml-4 my-3 space-y-1">
            <li><strong>Abbonamento Annuale:</strong> €5,00</li>
            <li><strong>Abbonamento Biennale:</strong> €8,50 (2 anni)</li>
            <li><strong>Abbonamento Triennale:</strong> €12,00 (3 anni)</li>
          </ul>
          <p>
            <strong>3.3 Notifica di Rinnovo:</strong> L'utente riceverà una comunicazione via email 30 giorni prima della 
            scadenza dell'abbonamento con le istruzioni per il rinnovo.
          </p>
          <p>
            <strong>3.4 Nessuna Commissione:</strong> Non sono previste commissioni sui contratti stipulati tra le parti 
            fuori dall'App.
          </p>
          <p>
            <strong>3.5 Fatturazione:</strong> Essendo la sede in Polonia, per le aziende italiane si applicherà il regime 
            del Reverse Charge (Inversione Contabile), previa verifica della validità della P.IVA nel sistema VIES.
          </p>

          <h2 className="text-xl font-semibold text-slate-900">Art. 4 – Limitazione di Responsabilità (Manleva Tecnica)</h2>
          <p>
            <strong>4.1 Responsabilità Tecnica:</strong> Automat.io è totalmente estranea all'esecuzione tecnica dei lavori. 
            Non risponde di errori di programmazione (PLC, Robotica, CNC), danni materiali agli impianti, fermi macchina 
            o perdite di produzione causati dai Professionisti contattati tramite l'App.
          </p>
          <p>
            <strong>4.2 Verifica Competenze:</strong> L'onere di verificare certificazioni, abilitazioni e referenze del 
            Professionista spetta esclusivamente all'Azienda.
          </p>

          <h2 className="text-xl font-semibold text-slate-900">Art. 5 – Esonero dal Rimborso</h2>
          <p>
            Il Servizio si considera erogato nel momento in cui viene fornito l'accesso ai dati di contatto. Pertanto, 
            la quota di iscrizione <strong>non è rimborsabile</strong> una volta effettuato il primo accesso all'area riservata.
          </p>

          <h2 className="text-xl font-semibold text-slate-900">Art. 6 – Legge Applicabile e Foro Competente</h2>
          <p>
            I presenti Termini sono regolati dalla legge polacca e dai regolamenti UE. Per ogni controversia tra l'Utente 
            e il Titolare, il foro competente esclusivo sarà quello di <strong>Lodz</strong>.
          </p>

          {/* Footer */}
          <div className="mt-12 pt-8 border-t border-slate-200">
            <p className="text-sm text-slate-500">
              Per qualsiasi domanda relativa ai presenti Termini di Servizio, contattare: {' '}
              <a href="mailto:deltaimpianti.de@gmail.com" className="text-orange-500 hover:underline">
                deltaimpianti.de@gmail.com
              </a>
            </p>
            <p className="text-sm text-slate-500 mt-2">
              Vedi anche: <Link to="/privacy" className="text-orange-500 hover:underline">Privacy Policy</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;
